import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalLoadingIndicatorService {
  readonly isLoading = signal(false);
  readonly isHideContent = signal(false);

  private activeLoadingRequests = 0;

  showLoading(hideContent = false): void {
    this.activeLoadingRequests += 1;
    this.isLoading.set(true);

    if (hideContent) {
      this.isHideContent.set(true);
    }
  }

  hideLoading(): void {
    if (this.activeLoadingRequests > 0) {
      this.activeLoadingRequests -= 1;
    }

    if (this.activeLoadingRequests === 0) {
      this.isLoading.set(false);
      this.isHideContent.set(false);
    }
  }
}
